'use strict';

(function () {
    'use strict';

    angular.module('group.selectionGroups', ['ui.router', 'common']);
})();